import React from 'react';
import MuiOutlinedInput, {
  OutlinedInputProps as MuiOutlinedInputProps,
} from '@material-ui/core/OutlinedInput';
import InputAdornment from '@material-ui/core/InputAdornment';
import styled from 'styled-components';

import { styledSystem, StyledSystemProps } from '../styledSystem';

interface InputProps
  extends Omit<MuiOutlinedInputProps, 'color' | 'margin'>,
    Omit<StyledSystemProps, 'right'> {
  color?:
    | 'primary'
    | 'secondary'
    | 'info'
    | 'warning'
    | 'error'
    | 'success'
    | 'default';
  bg?: 'default' | 'paper' | 'element';
  center?: boolean;
  right?: boolean;
  Adornment?: React.ReactElement;
  adornmentPosition?: 'start' | 'end';
}

export const Input = styled(
  ({
    color,
    margin,
    center,
    right,
    Adornment,
    adornmentPosition,
    ...props
  }: InputProps) => (
    <MuiOutlinedInput
      startAdornment={
        Adornment && adornmentPosition !== 'end' ? (
          <InputAdornment position="start">{Adornment}</InputAdornment>
        ) : null
      }
      endAdornment={
        Adornment && adornmentPosition === 'end' ? (
          <InputAdornment position="end">{Adornment}</InputAdornment>
        ) : null
      }
      {...props}
    />
  )
)`
  &&& {
    color: ${({ theme, color }) =>
      color ? theme.palette[color].main : theme.palette.default.contrastText};
    background-color: ${({ theme, bg }) =>
      bg ? theme.palette.background[bg] : theme.palette.background.element};
    border-width: 2px;
    border-radius: 50px;

    & div {
      color: ${({ theme, color }) =>
        color ? theme.palette[color].main : theme.palette.primary.main};
    }

    & fieldset {
      border-color: ${({ theme, color }) =>
        color ? theme.palette[color].main : theme.palette.primary.main};
      border-width: 2px;
      border-radius: 50px;
    }

    & input {
      padding-left: ${({ Adornment }) => (Adornment ? null : '24px')};
      padding-right: ${({ Adornment }) => (Adornment ? null : '24px')};
      text-align: ${({ center, right }) =>
        center ? 'center' : right ? 'right' : 'left'};
    }

    ${styledSystem}
  }
`;
